import React from 'react';
import { Gallery, GalleryType } from 'src/services';
import { GalleriesEmptyTable } from './GalleriesEmptyTable';
import { GalleriesList } from './GalleriesList';

interface GalleriesTableProps {
  galleries: Gallery[];
  navigateToCreateGalleryPage: () => void;
  navigateToEditGalleryPage: (galleryId: string, galleryType: GalleryType) => void;
  deleteGallery: (galleryId: string, galleryType: GalleryType) => void;
  navigateToGalleryPage: (galleryId: string, galleryType: GalleryType) => void;
}

export const GalleriesTable = ({
  galleries,
  navigateToCreateGalleryPage,
  navigateToEditGalleryPage,
  deleteGallery,
  navigateToGalleryPage,
}: GalleriesTableProps): JSX.Element => {
  if (galleries.length === 0) {
    return <GalleriesEmptyTable navigateToCreateGalleryPage={navigateToCreateGalleryPage} />;
  }

  return (
    <GalleriesList
      galleries={galleries}
      navigateToEditGalleryPage={navigateToEditGalleryPage}
      deleteGallery={deleteGallery}
      navigateToGalleryPage={navigateToGalleryPage}
    />
  );
};
